/**
 * @module estrutura/estrutura
 */

import { Plugin } from 'ckeditor5/src/core';
import EstruturaEditing from './estruturaediting';
import EstruturaUI from './ui/estruturaui';
import EstruturaLabelEditing from './label/estruturalabelediting';
import EstruturaLabelUI from './ui/estruturalabelui';

/**
 * The estrutura plugin.
 *
 * It loads the {@link module:estrutura/estruturaediting~EstruturaEditing EstruturaEditing feature}
 * and {@link module:estrutura/ui/estruturaui~EstruturaUI EstruturaUI feature}
 * and {@link module:estrutura/label/estruturalabelediting~EstruturaLabelEditing EstruturaLabelEditing feature}
 * and {@link module:estrutura/ui/estruturalabelui~EstruturaLabelUI EstruturaLabelUI feature}.
 *
 * @extends {Plugin}
 */
export default class Estrutura extends Plugin {
	/**
	 * @inheritDoc
	 */
	static get pluginName() {
		return 'Estrutura';
	}

	/**
	 * @inheritDoc
	 */
	static get requires() {
		return [ EstruturaEditing, EstruturaUI, EstruturaLabelEditing, EstruturaLabelUI ];
	}
}
